/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'telegram': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#61a8de" d="M0 0h32v32H0V0z"/><path pid="1" _fill="#fff" d="M25.197 7.064L3.798 15.403c-.693.27-.651 1.265.062 1.475l5.438 1.606 2.029 6.439a.934.934 0 001.558.373l2.811-2.871 5.516 4.049a1.151 1.151 0 001.808-.692l3.653-17.467a1.1 1.1 0 00-1.477-1.251zm-2.683 3.876l-9.94 8.79a.537.537 0 00-.177.34l-.383 3.402c-.012.111-.168.126-.201.019l-1.574-5.073a.534.534 0 01.229-.612l11.738-7.28c.27-.168.546.204.308.414z"/>'
  }
})
